import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Hidden from '@mui/material/Hidden';
import useStyles from './Styles';

interface Props {
    name: string,
    value: any,
	noWrap?: boolean,
}

const RowTable:React.FC<Props> = (props)=> {
    const classes = useStyles();
	let whiteSpace = 'normal' as 'normal'|'nowrap';
	if( props.noWrap!==null && props.noWrap===true ){
		whiteSpace = 'nowrap';
	}
	return (
        <TableRow>
            <Hidden smDown implementation="js">
                <TableCell sx={{padding:'0.5em',paddingRight:{sm:'2em',xs:'0em'},whiteSpace:`${whiteSpace}`}} className={classes.rowLabel}>{props.name}</TableCell>
            </Hidden>
            <TableCell style={{padding:"0.5em 0"}}>
                <Hidden smUp implementation="js">
                    <div className={classes.rowLabel} style={{paddingLeft:'0.5em'}}>{props.name}</div>
                </Hidden>
                <span className={classes.rowValue}>{props.value}</span>
            </TableCell>
        </TableRow>
    );
}

export default RowTable;
